'use strict';

var angularModule = angular.module('t2g.common.data-access.tarif590', []);

module.exports = angularModule;

angularModule.factory('Tarif590Resource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/tarif590';

  var resource = $resource(
    resourceUrl,
    {},
    {
      list: { method: 'GET', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('Tarif590DA', function($q, Tarif590Resource) {
  var services;

  return {
    list: function() {
      if (services) {
        return $q.when(services);
      } else {
        return Tarif590Resource.list().$promise.then(function(response) {
          services = response.services;
          return services;
        });
      }
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/tarif590.js